import React from "react";

const hasChanged = (beforeItem, afterItem, field) => {
  return beforeItem[field] !== afterItem[field];
};

const FlooringRatesCard = ({ outline, title, data, compareData }) => {
  return (
    <div className="flooring-full-card">
      {data && (
        <div>
          <h1
            className={`text-[#0560FB] text-[12px] font-[600] py-[6px] px-[20px] min-w-[81px] rounded-[4px] inline-block ${
              outline
                ? "border border-[#0560FB] text-center"
                : "bg-[#DDEAFF] text-center"
            }`}
          >
            {title}
          </h1>
          <div className="vehicle-types-group">
            {data &&
              data.map((item, index) => {
                const beforeItem = compareData && compareData[index];
                return (
                  <div key={index} className="vehicle-types-list w-full">
                    <h2>{item.name}</h2>
                    <h3>
                      Flooring Int. (30 days):{" "}
                      <span
                        className={
                          beforeItem &&
                          (hasChanged(beforeItem, item, "interest_from") ||
                            hasChanged(beforeItem, item, "interest_to"))
                            ? "!text-[#0560FB]"
                            : ""
                        }
                      >
                        ${item.interest_from}% - ${item.interest_to}%
                      </span>
                    </h3>
                    <h4>
                      Admin Fee:{" "}
                      <span
                        className={
                          beforeItem &&
                          (hasChanged(beforeItem, item, "admin_fee_from") ||
                            hasChanged(beforeItem, item, "admin_fee_to"))
                            ? "!text-[#0560FB]"
                            : ""
                        }
                      >
                        ${item.admin_fee_from} - ${item.admin_fee_to}
                      </span>
                    </h4>
                  </div>
                );
              })}
          </div>
        </div>
      )}
      {!data && (
        <div className="flex-[1]">
          <div className="flex justify-between items-center p-[17px_26px]">
            No Preview for Notifications, Please click the notification to see
            details page
          </div>
        </div>
      )}
    </div>
  );
};

const FlooringNotificationCard = ({ beforeData, afterData }) => {
  const isScheduled =
    beforeData
      ?.map((it) => it?.scheduled_date_time)
      ?.filter((itx) => itx !== null && itx !== undefined)?.length > 0 &&
    afterData
      ?.map((it) => it?.scheduled_date_time)
      ?.filter((itx) => itx !== null && itx !== undefined)?.length > 0;
  return (
    <>
      <FlooringRatesCard
        outline={false}
        title={beforeData?.length > 0 ? "After" : "New"}
        data={afterData}
        compareData={beforeData}
      />
      {beforeData?.length > 0 && (
        <FlooringRatesCard outline={true} title={"Before"} data={beforeData} />
      )}
    </>
  );
};

export default FlooringNotificationCard;
